import * as DashboardConstants from '.././DashboardConstants';

export const SchedulingEfficiencyTableHeaders = [
    {
        key: 'processname',
        header: DashboardConstants.ProcessName
    },
    {
        key: 'botid',
        header: DashboardConstants.BotId
    },
    {
        key: 'competency',
        header: DashboardConstants.Competency
    },
    {
        key: 'component',
        header: DashboardConstants.Component
    },
    {
        key: 'reasonforschedulermiss',
        header: DashboardConstants.ReasonForSchedulerMiss
    },
    {
        key: 'deliverymodel',
        header: DashboardConstants.DeliveryModel
    },
    {
        key: 'requestedby',
        header: DashboardConstants.RequestedBy
    },
    {
        key: 'geo',
        header: DashboardConstants.Geo
    },
    {
        key: 'reruns',
        header: DashboardConstants.Reruns
    },
    {
        key: 'schmisses',
        header: DashboardConstants.Schmisses
    },

];

export const SchedulingEfficiencyTableData = [
    {
        id: 1,
        'processname': 122,
        'botid': 121,
        'competency': 454,
        'component': 323,
        'reasonforschedulermiss': 87,
        'deliverymodel': 343,
        'requestedby': 77,
        'geo': 123,
        'reruns': 975,
        'schmisses': 557
    },
    {
        id: 2,
        'processname': 313,
        'botid': 111,
        'competency': 300,
        'component': 400,
        'reasonforschedulermiss': 900,
        'deliverymodel': 677,
        'requestedby': 12,
        'geo': 123,
        'reruns': 888,
        'schmisses': 557
    },
    {
        id: 3,
        'processname': 313,
        'botid': 222,
        'competency': 232,
        'component': 344,
        'reasonforschedulermiss': 800,
        'deliverymodel': 544,
        'requestedby': 23,
        'geo': 7,
        'reruns': 76,
        'schmisses': 89
    },
    {
        id: 4,
        'processname': 313,
        'botid': 333,
        'competency': 123,
        'component': 321,
        'reasonforschedulermiss': 345,
        'deliverymodel': 543,
        'requestedby': 11,
        'geo': 123,
        'reruns': 12,
        'schmisses': 1
    },
    {
        id: 5,
        'processname': 12,
        'botid': 121,
        'competency': 3,
        'component': 1,
        'reasonforschedulermiss': 87,
        'deliverymodel': 55,
        'requestedby': 75,
        'geo': 44,
        'reruns': 55,
        'schmisses': 77
    },
    {
        id: 6,
        'processname': 111,
        'botid': 222,
        'competency': 3,
        'component': 1,
        'reasonforschedulermiss': 87,
        'deliverymodel': 555,
        'requestedby': 888,
        'geo': 44,
        'reruns': 12,
        'schmisses': 77
    },
]